import DaikinLogoHTML from "components/atoms/DaikinLogoHTML";
import colors from "constants/colors";
import React, { memo, ReactNode } from "react";
import styled from "styled-components/macro";
import {
  Container,
  CopyCode,
  CopyCodeIcon,
  CopyTooltipPop,
  Dash,
  DateLine,
  DescLine,
  HalfCircle,
  HalfCircles,
  HeadLine,
  Logo,
  OutsideWrapContainer,
  Text,
  WrapApplyButton,
  WrapContainer,
  WrapDateLine,
} from "./componentStyledCoupon";
import "./index.scss";

interface CouponProps {
  children?: React.ReactNode;
  selected?: boolean;
  copied?: boolean;
  data: CouponItem;
  type: "small" | "large";
  parentBgColor: keyof typeof colors;
  className?: string;
  hasCrossSellAdded?: boolean;
  applyButton?: ReactNode;
  onSelect?: () => void;
  onShow?: () => void;
  onShowNotify?: () => void;
  onCopied?: () => void;
}

const Coupon: React.FC<CouponProps> = ({
  children,
  selected,
  copied,
  data,
  parentBgColor,
  type,
  className,
  applyButton,
  hasCrossSellAdded,
  onSelect,
  onShow,
  onShowNotify,
  onCopied,
}) => {
  const copyToClipboard = () => {
    const copyText = document.getElementById(`copyInput-${data.id}`);
    if (copyText) {
      const inputCopy = copyText as HTMLInputElement;
      inputCopy.select();
      inputCopy.setSelectionRange(0, 100);
      document.execCommand("copy");
    }
  };

  return type === "small" ? ( // small COUPON ITEM type
    <WrapContainer
      className={className}
      type={type}
      selected={selected}
      onClick={() => {
        if (hasCrossSellAdded && onShowNotify) {
          onShowNotify();
        } else if (onShow) {
          onShow();
        }
      }}
      disabled={hasCrossSellAdded}
    >
      <HalfCircles>
        <Dash />
        <HalfCircle background={parentBgColor} position="top"></HalfCircle>
        <HalfCircle background={parentBgColor} position="bottom"></HalfCircle>
      </HalfCircles>
      <Container title={children as string}>
        <Logo>
          <DaikinLogoHTML
            width={18}
            theme={selected ? "white" : "black-blue"}
            type="small"
          />
        </Logo>
        <Text>{children}</Text>
      </Container>
    </WrapContainer>
  ) : (
    // large COUPON ITEM type
    <OutsideWrapContainer>
      <WrapContainer className={className} type={type} selected={selected}>
        <HiddenInput
          type="text"
          value={data.code}
          id={`copyInput-${data.id}`}
        />
        <HalfCircles>
          <Dash />
          <HalfCircle background={parentBgColor} position="top"></HalfCircle>
          <HalfCircle background={parentBgColor} position="bottom"></HalfCircle>
        </HalfCircles>
        <Container title={children as string}>
          {
            // desktop
          }
          <Logo>
            <DaikinLogoHTML
              width={72}
              theme={selected ? "white" : "black-blue"}
              type="large"
            />
          </Logo>
          {
            // mobile & desktop
          }
          <HeadLine>
            <Text>{data.label}</Text>
            <CopyCode
              onClick={() => {
                onCopied && onCopied();
                copyToClipboard();
              }}
            >
              {data.code}
              <CopyCodeIcon
                iconName={
                  !selected
                    ? copied
                      ? "green-tick"
                      : "copy"
                    : copied
                      ? "white-tick"
                      : "copy-white"
                }
              />
            </CopyCode>
          </HeadLine>
          <DescLine
            dangerouslySetInnerHTML={{
              __html: data.desc,
            }}
          />
          <WrapDateLine>
            <DateLine>
              Hạn sử dụng: <strong>{data.expiredDate}</strong>
            </DateLine>
            <WrapApplyButton>{applyButton}</WrapApplyButton>
          </WrapDateLine>
        </Container>
      </WrapContainer>
      <CopyTooltipPop copied={copied}>Đã copy {data.code}!</CopyTooltipPop>
    </OutsideWrapContainer>
  );
};

Coupon.defaultProps = {};

const HiddenInput = styled.input`
  position: absolute;
  right: 0;
  z-index: -1;
  opacity: 0;
`;

export default memo(Coupon);
